import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { PAY } from "@/constants/testIds";
import { Check } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const [code, setCode] = useState(null);
  const [kind, setKind] = useState("booking_fee");

  useEffect(() => {
    if (!sid) return;
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        setCode(data.booking_code);
        setKind(data.kind || "booking_fee");
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (data.payment_status === "unknown") { setStatus("pending"); return; }
      } catch {}
      tries++;
      if (tries < 8) setTimeout(poll, 1500);
      else setStatus("pending");
    };
    poll();
  }, [sid]);

  const isBookingFee = kind === "booking_fee";

  return (
    <div className="max-w-2xl mx-auto px-6 py-24 text-center">
      <div className="w-16 h-16 rounded-full bg-[#0F172A] text-[#FFFFFF] flex items-center justify-center mx-auto">
        <Check size={28}/>
      </div>
      <div className="overline mt-8">{isBookingFee ? "Booking confirmed" : "Deposit received"}</div>
      <h1 data-testid={PAY.paymentStatus} className="font-serif-display text-5xl mt-4">
        {status === "paid"
          ? (isBookingFee ? "Your slot is secured." : "Deposit received.")
          : status === "checking" ? "Confirming payment..." : "Almost there..."}
      </h1>
      {code && (
        <div className="mt-8 border border-[#E2E8F0] bg-[#F8FAFC] p-6 inline-block">
          <div className="overline">Your booking code</div>
          <div className="font-serif-display text-3xl mt-2 tracking-widest">{code}</div>
        </div>
      )}
      <p className="mt-8 text-[#4A4A4A] max-w-md mx-auto">
        {isBookingFee
          ? "Hedieh will review your photos and message you on WhatsApp within 24 hours to confirm the appointment and any additional deposit if needed."
          : "You'll receive a WhatsApp confirmation shortly. See you at the shop soon."}
      </p>
      <div className="mt-10 flex gap-3 justify-center flex-wrap">
        <Link to="/track" className="px-8 py-3 border border-[#0F172A] text-xs uppercase tracking-[0.25em] hover:bg-[#0F172A] hover:text-[#FFFFFF]">
          Track My Order
        </Link>
        <Link to="/" className="px-8 py-3 bg-[#D4AF37] text-[#0F172A] text-xs uppercase tracking-[0.25em] hover:bg-[#B8941F]">
          Back to Home
        </Link>
      </div>
    </div>
  );
}
